import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { strictEqual } from 'assert';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { DataTablesResponseViewModel } from '../../models/data-tables-response-view-model';
import { TerminalSignUpViewModel } from '../../models/terminal-signup-view-model';
import { TerminalDTViewModel } from '../../models/terminal-dt-view-model';
import { AuthenticationService } from '../../services/authentication.service';
import { PermissionEnum } from '../../services/guards/permissions';
import { TerminalService } from '../../services/terminal.service';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { TerminalCardViewComponent } from '../terminal-card-view/terminal-card-view.component';
import { TerminalsConfigurationComponent } from '../terminals-configuration/terminals-configuration.component';
import { DatePipe } from '@angular/common';
import { DeliveryNoteComponent } from '../delivery-note/delivery-note.component';
import { ConfirmationDialogComponent } from '../../partials/confirmation-dialog/confirmation-dialog.component';
import { CreateResult } from '../../models/create-result';
import { DeleteTicketComponent } from '../delete-ticket/delete-ticket.component';
import { TerminalSignUpDownloadModel } from '../../models/add-update-terminal-sign-up-view-model';
import { IdTextPair } from '../../models/id-text-pair';
import { DeviceMakeViewModel } from '../../models/device-make-view-model';
import { DeviceModelViewModel } from '../../models/device-model-view-model';
import { AddUpdateTerminalLogViewModel } from '../../models/add-update-terminal-log-view-model';

@Component({
  selector: 'app-terminal-staging',
  templateUrl: './terminal-staging.component.html',
  styleUrls: ['./terminal-staging.component.scss']
})
export class TerminalStagingComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false })
  public dataTableElement: DataTableDirective;
  public dtElement: DataTableDirective;

  public canManage = false;
  public raiseDanger: boolean = false;
  public raiseWarning: boolean = false;
  public success: boolean = false;
  public message: string;
  public danger: string;
  public warning: string;
  public canView: boolean;
  public merchantNumber = '';
  public canEditMerchantSignUp: boolean;
  public canEditTerminalSignUp: boolean;
  public terminal: TerminalDTViewModel;
  public terminals: TerminalSignUpViewModel[] = [];
  public terminalSignUpDefault: TerminalSignUpViewModel[] = [];
  public newTerminals: TerminalSignUpViewModel[] = [];
  public newTerminalsBulk: TerminalSignUpViewModel[] = [];
  public terminalsOnPrep: TerminalSignUpViewModel[] = [];
  public terminalsOnPrepBulk: TerminalSignUpViewModel[] = [];
  public configurationComplete: TerminalSignUpViewModel[] = [];
  public configurationCompleteBulk: TerminalSignUpViewModel[] = [];
  public dispatchedTerminals: TerminalSignUpViewModel[] = [];
  public dispatchedTerminalsBulk: TerminalSignUpViewModel[] = [];
  private _destroyed$ = new Subject<any>();
  private searchEndpoint = `${environment.apiUrl}/api/terminal/searchStaging/`;
  public dtTrigger: Subject<boolean> = new Subject();
  public searchDebounce = new Subject<string>();
  public canDeleteTicket: boolean;
  public canGenerateRemedyCall: boolean;
  public canArchiveTerminalTicket: boolean;
  public canResetTerminalTicket: boolean;
  public canResendNotification: boolean;
  public deviceList: TerminalSignUpDownloadModel[] = [];
  public deviceMakeList: DeviceMakeViewModel[] = [];
  public deviceModelList: DeviceModelViewModel[];
  public devices: TerminalSignUpViewModel[] = [];

  public merchantIdSearch = '';
  public terminalIdSearch = '';
  public wayBillSearch = '';
  public changedBySearch = '';
  public trackingId = '';
  public EditButton: string;
  public EditView: string;
  private refreshInterval: any;
  public client: boolean;
  public createResult: CreateResult;
  public canDispatchTerminals: boolean = false;
  public terminalLog: AddUpdateTerminalLogViewModel;
  constructor(private _httpClient: HttpClient,
    private _route: ActivatedRoute,
    private _router: Router,
    private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _terminalService: TerminalService,
    private _toastService: ToastrService,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe) {

    this._route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {

      this.canDispatchTerminals = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTerminalDispatched]);

      this.canManage = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewMerchantSignUp]);
      if (!this.canManage) {
        this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
        this._router.navigate(['/']);
      }

      this.canEditTerminalSignUp = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditTerminaSignUpStaging]);
      this.canDeleteTicket = this._userDataStore.hasRequiredPermissions([PermissionEnum.DeleteTerminalTicket]);
      this.canGenerateRemedyCall = this._userDataStore.hasRequiredPermissions([PermissionEnum.GenerateRemedyCall]);
      this.canArchiveTerminalTicket = this._userDataStore.hasRequiredPermissions([PermissionEnum.ArchiveTerminalTicket]);
      this.canResetTerminalTicket = this._userDataStore.hasRequiredPermissions([PermissionEnum.ResetTerminalTicket]);
      //this.canResendNotification = this._userDataStore.hasRequiredPermissions([PermissionEnum.ResendNotification])


      if (params.id != '' && params.id != undefined) {
        this.merchantNumber = params.id;
      }

    });

    this.client = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddTerminalSignUpNotes], []);
    if (this.canEditTerminalSignUp && this.client) {
      this.client = false;
    }


  }

  async ngOnInit() {
    this.deviceMakeList = await this._terminalService.GetDeviceMakes();;
    this.deviceModelList = await this._terminalService.GetDeviceModels();
  }

  public columns: any[] = [
    { data: 'merchantNumber', title: 'New request', visible: true, searchable: true, search: { value: this.merchantIdSearch, regex: true } },
    { data: 'terminalid', title: 'Terminal preparation', visible: true, searchable: true, search: { value: this.terminalIdSearch, regex: true } },
    { data: 'wayBill', title: 'Configuration complete', visible: true, searchable: true, search: { value: this.wayBillSearch, regex: true } },
    { data: 'inUseDate', title: 'Dispatched', visible: true, searchable: true, search: { value: this.changedBySearch, regex: true } },
  ];

  public async ngAfterViewInit(): Promise<void> {
    this.dtTrigger.next();
    // await this.init();
    this.dataTableElement?.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }

  private resetDatatable(): void {

    this.dataTableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });

  }

  private async refreshTable(): Promise<void> {

    await this.dataTableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      this.setupFilters();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  public setupFilters(): void {
    const searchColumns = this.columns.map((col) => {
      if (!!(col).search) {
        return { search: (col).search.value, regex: (col).search.regex };
      } else {
        return null;
      }
    });
    //this.dtOptions.searchCols = searchColumns;
    this.dataTableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      let i = 0;
      for (const item of searchColumns) {
        if (item) {
          dtInstance.column(i).search(item.search, item.regex);
        }
        i++;
      }
    })
  }

  private searchColumns = this.columns.map((col) => {
    if (!!col.search) {
      return { search: col.search.value, regex: col.search.regex };
    } else {
      return null;
    }
  });

  public dtOptions: DataTables.Settings = {
    pageLength: 100,
    serverSide: true,
    processing: true,

    ajax: (dataTablesParameters: any, callback) => {

      this._httpClient
        .post<DataTablesResponseViewModel>(

          this.getUrl(),
          dataTablesParameters, {}
        ).subscribe(resp => {

          if (resp != null) {


            this._ngxUiLoaderService.start();
            this.terminals = resp?.data;
            if (this.terminals.length <= 1) {
              this.terminalSignUpDefault = this.terminals;
            } else {
              this.terminalSignUpDefault[0] = this.terminals[0];
            }

            //=========================================================================NEW

            this.newTerminals = this.terminals.filter(p => p.status === "New" && !p.bulkOrder).sort((a, b) => {
              const dateA = new Date(a.changedOn);
              const dateB = new Date(b.changedOn);
              return dateB.getTime() - dateA.getTime();
            });

            this.newTerminalsBulk = this.terminals.filter(p => p.status === "New" && p.bulkOrder).sort((a, b) => {
              const dateA = new Date(a.changedOn);
              const dateB = new Date(b.changedOn);
              return dateB.getTime() - dateA.getTime();
            });

            //format duplicates
            const uniqueTerminalIds = new Set<string>();
            const uniqueTerminals = this.newTerminalsBulk.filter((terminal) => {

              if (uniqueTerminalIds.has(terminal.merchantNumber)) {
                return false;
              } else {
                uniqueTerminalIds.add(terminal.merchantNumber);
                return true;
              }
            });

            //bind
            this.newTerminalsBulk = uniqueTerminals;


            //=========================================================================Terminal preparation

            this.terminalsOnPrep = this.terminals.filter(p => p.status === "Terminal preparation" && !p.bulkOrder).sort((a, b) => {
              const dateA = new Date(a.changedOn);
              const dateB = new Date(b.changedOn);
              // Compare dates in descending order
              return dateB.getTime() - dateA.getTime();
            });

            this.terminalsOnPrepBulk = this.terminals.filter(p => p.status === "Terminal preparation" && p.bulkOrder).sort((a, b) => {
              const dateA = new Date(a.changedOn);
              const dateB = new Date(b.changedOn);
              return dateB.getTime() - dateA.getTime();
            });

            //format duplicates
            const uniqueTerminalIdsOnPrep = new Set<string>();
            const uniqueTerminalsOnPrep = this.terminalsOnPrepBulk.filter((terminal) => {
              if (uniqueTerminalIdsOnPrep.has(terminal.merchantNumber)) {
                return false;
              } else {
                uniqueTerminalIdsOnPrep.add(terminal.merchantNumber);
                return true;
              }
            });

            //bind
            this.terminalsOnPrepBulk = uniqueTerminalsOnPrep;

            //==============================================================================Configuration complete
            this.configurationComplete = this.terminals.filter(p => p.status === "Configuration complete" && !p.bulkOrder).sort((a, b) => {
              const dateA = new Date(a.changedOn);
              const dateB = new Date(b.changedOn);
              // Compare dates in descending order
              return dateB.getTime() - dateA.getTime();
            });


            this.configurationCompleteBulk = this.terminals.filter(p => p.status === "Configuration complete" && p.bulkOrder).sort((a, b) => {
              const dateA = new Date(a.changedOn);
              const dateB = new Date(b.changedOn);
              return dateB.getTime() - dateA.getTime();
            });

            //format duplicates
            const uniqueTerminalIdsOnComplete = new Set<string>();
            uniqueTerminalIdsOnPrep.forEach(item => {

              uniqueTerminalIdsOnComplete.add(item);
            });

            const uniqueTerminalsOnComplete = this.configurationCompleteBulk.filter((terminal) => {
              if (uniqueTerminalIdsOnComplete.has(terminal.merchantNumber)) {
                return false;
              } else {
                uniqueTerminalIdsOnComplete.add(terminal.merchantNumber);
                return true;
              }
            });

            //bind
            this.configurationCompleteBulk = uniqueTerminalsOnComplete;


            //================================================================================Dispatched
            this.dispatchedTerminals = this.terminals.filter(p => p.status === "Dispatched" && !p.bulkOrder).sort((a, b) => {
              const dateA = new Date(a.changedOn);
              const dateB = new Date(b.changedOn);
              // Compare dates in descending order
              return dateB.getTime() - dateA.getTime();
            });


            this.dispatchedTerminalsBulk = this.terminals.filter(p => p.status === "Dispatched" && p.bulkOrder).sort((a, b) => {
              const dateA = new Date(a.changedOn);
              const dateB = new Date(b.changedOn);
              return dateB.getTime() - dateA.getTime();
            });

            //format duplicates
            const uniqueTerminalIdsDispatched = new Set<string>();
            const uniqueTerminalsDispatched = this.dispatchedTerminalsBulk.filter((terminal) => {
              if (uniqueTerminalIdsDispatched.has(terminal.merchantNumber)) {
                return false;
              } else {
                uniqueTerminalIdsDispatched.add(terminal.merchantNumber);
                return true;
              }
            });

            //bind
            this.dispatchedTerminalsBulk = uniqueTerminalsDispatched;


            //================================================================================

            this._ngxUiLoaderService.stop();

            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          }
        });
    },
    columns: this.columns,
    searchCols: this.searchColumns
  };

  public getUrl(): string {

    if (this.merchantNumber == '')
      return this.searchEndpoint;
    else
      return this.searchEndpoint + this.merchantNumber
  }
  public get displayColumns() {
    return this.dtOptions.columns.filter(x => x.visible != false);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    clearInterval(this.refreshInterval);
  }

  public async viewTrackTerminal(terminal: TerminalSignUpViewModel): Promise<void> {
    this._router.navigate(['management', 'terminals-tracking', terminal.wayBill]);
  }

  public trackTerminal(terminal: TerminalSignUpViewModel): boolean {
    if (terminal.wayBill != "" && terminal.wayBill != null && terminal.status) {
      return true;
    }
    else {
      return false;
    }
  }

  public async editTerminal(terminal: TerminalSignUpViewModel): Promise<void> {
    debugger;
    const modalRef = this._modalService.open(TerminalCardViewComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    modalRef.componentInstance.terminalSignUp = terminal;
    //await modalRef.result;

    // Close modal event listener
    await modalRef.result.then((result) => {
      // Call the function to execute DataTables code after modal is closed
      //this.redirect();
      this.refreshTable();
    });

  }

  public async editBulk(merchant: TerminalSignUpViewModel): Promise<void> {

    const modalRef = this._modalService.open(TerminalsConfigurationComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    modalRef.componentInstance.id = merchant.merchantNumber;
    //await modalRef.result;

    // Close modal event listener
    await modalRef.result.then((result) => {
      // Call the function to execute DataTables code after modal is closed
      //this.redirect();
      this.refreshTable();
    });

  }

  public async viewDeliveryNote(terminal: TerminalSignUpViewModel): Promise<void> {

    const modalRef = this._modalService.open(DeliveryNoteComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    modalRef.componentInstance.merchantNumberId = terminal.merchantNumber;
    modalRef.componentInstance.terminalId = terminal.terminalId;
    if (terminal.bulkOrder) {
      modalRef.componentInstance.type = 'bulk';
    }
    else {
      modalRef.componentInstance.type = 'sigle';
    }//await modalRef.result;

    // Close modal event listener
    await modalRef.result.then((result) => {
      // Call the function to execute DataTables code after modal is closed
      //this.redirect();
      this.refreshTable();
    });

  }

  redirect() {
    this._ngxUiLoaderService.start();

    if (this.merchantNumber == '') {
      this._router.navigate(['management', 'terminal-staging']);
    }
    else {

      this._router.navigate(['/management/terminal-staging/' + this.merchantNumber]);
      //this._router.navigate(['management', 'terminal-staging', this.merchantNumber])
    }
    this._ngxUiLoaderService.stop();
  }


  public inUseBy(terminal: TerminalSignUpViewModel): string {
    if (terminal?.inUseBy == this._userDataStore.currentUserValue.email) {
      return "Edit ticket";
    }
    else if (terminal.status == "New") {
      return "Claim ticket";
    }
    return "View ticket";//#6293bb
  }

  public backgroudColor(terminal: TerminalSignUpViewModel): string {

    if (terminal?.inUseBy == this._userDataStore.currentUserValue.id) {
      return "style='!background-color: red; border-color:red'";
    }
    else if (terminal.status == "New") {
      return "style='!background-color: red; border-color:red";
    }
    return "style='background-color: #6293bb'; border-color:#6293bb";//
  }

  public async deleteTerminal(terminal: TerminalSignUpViewModel, isBulk: boolean) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = 'Delete';
    dialogRef.componentInstance.cancelButtonText = 'Cancel';
    dialogRef.componentInstance.title = 'Delete ticket';
    dialogRef.componentInstance.message = 'Are you sure you want to delete the selected ticket?'

    const result = await dialogRef.result;
    if (result) {
      this.addDeleteNotes(terminal, isBulk);
      dialogRef.close();
    }
  }

  public async addDeleteNotes(terminalSignUp: TerminalSignUpViewModel, isBulk: boolean) {

    //this._ngxUiLoaderService.start();

    const modalRef = this._modalService.open(DeleteTicketComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'l',
      backdrop: 'static'
    });

    modalRef.componentInstance.terminalSignUp = terminalSignUp;
    modalRef.componentInstance.isBulk = isBulk;

    await modalRef.result.then((result) => {
      modalRef.close();
      this.refreshTable();
    });

    //this._ngxUiLoaderService.stop();
  }

  public async archiveTerminal(terminalSignUp: TerminalSignUpViewModel, isBulk: boolean) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = 'Archive';
    dialogRef.componentInstance.cancelButtonText = 'Cancel';
    dialogRef.componentInstance.title = 'Archive ticket';
    dialogRef.componentInstance.message = 'Are you sure you want to archive the selected ticket?'

    //const result = await dialogRef.result;
    await dialogRef.result.then(async (result) => {

      if (result) {
        this.createResult = await this._terminalService.ArchiveTerminalSignUp(terminalSignUp, isBulk);
        if (this.createResult.success) {
          this._toastService.success(this.createResult.message, "Success");
        }
        else {
          this._toastService.success(this.createResult.message, "Error");
        }
        dialogRef.close();
      }

      this.refreshTable();
    });
  }

  public async resetTerminal(terminalSignUp: TerminalSignUpViewModel, isBulk: boolean) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = 'Reset';
    dialogRef.componentInstance.cancelButtonText = 'Cancel';
    dialogRef.componentInstance.title = 'Reset ticket';
    dialogRef.componentInstance.message = 'Are you sure you want to reset the selected ticket?'

    const result = await dialogRef.result;
    await dialogRef.result.then(async (result) => {

      if (result) {
        this.createResult = await this._terminalService.ResetTerminalSignUp(terminalSignUp, isBulk);
        if (this.createResult.success) {
          this._toastService.success(this.createResult.message, "Success");
        }
        else {
          this._toastService.success(this.createResult.message, "Error");
        }
        dialogRef.close();
      }

      this.refreshTable();


    });

  }

  public async viewbulkOrders(terminal: TerminalSignUpViewModel) {
    this._ngxUiLoaderService.start();

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = false;
    dialogRef.componentInstance.acceptButtonText = "Close";
    dialogRef.componentInstance.title = "Terminals details";

    let counter = 0;
    var str = [];

    var merchantnumber = terminal.merchantNumber;
    this.devices = await this._terminalService.GetBulkTerminalSignedUpByMerchantStatus(merchantnumber, 'New');

    this.devices.forEach(async terminal => {
      counter++;
      str.push("Terminal (" + counter + "): <b>" + terminal.terminalId + "</b>, Make: <b>" + this.deviceMakeList.find(x => x.id == Number(terminal.make)).make + "</b>, Model: <b>" + this.deviceModelList.find(x => x.id == Number(terminal.model)).model + "</b>");

    });
    dialogRef.componentInstance.listMessage = str;


    this._ngxUiLoaderService.stop();
  }

  public async retrySendingNotification(terminal: TerminalSignUpViewModel, type: string) {


    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = 'Generate Remedy call';
    dialogRef.componentInstance.cancelButtonText = 'Cancel';
    dialogRef.componentInstance.title = 'Generate Remedy call';
    dialogRef.componentInstance.message = 'Are you sure you want to generate a Remedy call?'

    const result = await dialogRef.result;
    if (result) {
      dialogRef.close();
      this._ngxUiLoaderService.start();
      this.createResult = await this._terminalService.RetrySendNotification(terminal, type);
      if (this.createResult.success) {
        this._toastService.success('Remedy call successfully generated.', "Success");
      }
      else {
        this._toastService.error('Failed generating a Remedy call.', "Error");
      }
      this._ngxUiLoaderService.stop();
    }
  }

  public async dispatch(terminal: TerminalSignUpViewModel, type: string) {

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = 'Dispatch';
    dialogRef.componentInstance.cancelButtonText = 'Cancel';
    dialogRef.componentInstance.title = 'Dispatch terminal(s)';
    dialogRef.componentInstance.message = 'Are you sure you want to dispatch?';

    

    const result = await dialogRef.result;
    if (result) {
      dialogRef.close();
      this._ngxUiLoaderService.start();

      if (type == 'bulk') {
        this.createResult = await this._terminalService.DispatchTerminal(terminal.merchantNumber);
      }
      else {
        this.createResult = await this._terminalService.DispatchTerminal(terminal.serialNumber);
      }

      if (this.createResult.success) {
        this._toastService.success('Terminal(s) dispatched successfully.', "Success");
               
        debugger;
        if (type != 'bulk') {

          this.terminalLog = {
            CustodianshipId: "Zoho",
            EventId: 3, //device registration
            MerchantNumber: terminal.merchantNumber,
            TerminalId: terminal.terminalId,
            SerialNumber: terminal.serialNumber
          };
          const logResult = await this._terminalService.LogTerminalInfor(this.terminalLog);
        }
        else {
          //get all terminals associated with the merchant and of type bulk
          this.terminals = await this._terminalService.GetBulkTerminalSignedUpByMerchant(terminal.merchantNumber);
          if (this.terminals.length > 1) {
            this.terminals.forEach(async (item, count) => {

              this.terminalLog = {
                CustodianshipId: "Zoho",
                EventId: 3, //device registration
                MerchantNumber: terminal.merchantNumber,
                TerminalId: terminal.terminalId,
                SerialNumber: terminal.serialNumber
              };

              const logResult = await this._terminalService.LogTerminalInfor(this.terminalLog);
            });
          }
        }
      }
      else {
        this._toastService.error('An error occured while dispatching. Contact system administrator.', "Error");
      }

      await dialogRef.result.then((result) => {
        // Call the function to execute DataTables code after modal is closed
        //this.redirect();
        this.refreshTable();
      });


      this._ngxUiLoaderService.stop();

    }
  }
}


